import { type QConfigTableData } from '@exam-management/common/types';
import { QConfigStructureCategory, type QConfigStatus } from '@exam-management/graphql';
import { randomUUID } from '@shared/utils';

import { LOSTableRow, TopicTableRow } from '../../components';

interface QuestionConditionsTableRowProps {
  rowData: QConfigTableData;
  childrenData: QConfigTableData[];
  status: QConfigStatus;
  onUpdate: () => void;
}

export default function QuestionConditionsTableRow(
  props: Readonly<QuestionConditionsTableRowProps>,
) {
  const { rowData, childrenData, status, onUpdate } = props;
  const uuid = randomUUID();

  if (!childrenData.length) {
    return null;
  }

  const isTopic = childrenData.some((row) => row.category === QConfigStructureCategory.Topic);
  const isLOS = childrenData.every(
    (row) => row.category === QConfigStructureCategory.LearningObjectiveStatement,
  );

  if (isTopic) {
    return (
      <TopicTableRow
        key={`${uuid}-${rowData.id}`}
        rows={childrenData}
        data={rowData}
        status={status}
        onUpdate={onUpdate}
      />
    );
  }

  if (isLOS) {
    const losNames = childrenData
      .filter(
        (row) =>
          row.category === QConfigStructureCategory.LearningObjectiveStatement && row.name !== null,
      )
      .map((row) => row.name as string);

    return (
      <LOSTableRow
        key={`${uuid}-${rowData.id}`}
        data={rowData}
        losNames={losNames}
        status={status}
        onUpdate={onUpdate}
      />
    );
  }

  return null;
}
